import { render, staticRenderFns } from "./TemplateFormPage.vue?vue&type=template&id=3fe5eb54"
import script from "./TemplateFormPage.vue?vue&type=script&lang=js"
export * from "./TemplateFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports